import { portfolioStatistics } from "./portfolioStatistics";
import {
  Attrs,
  usePerformanceByAssetClass,
} from "./usePerformanceByAssetClass";

export const usePortfolioStatisticsByAssetClass = (attrs: Attrs) => {
  const query = usePerformanceByAssetClass(attrs);
  return {
    ...query,
    total: portfolioStatistics(query.total),
    allHoldings: portfolioStatistics(query.allHoldings),
    funds: portfolioStatistics(query.funds),
    etfs: portfolioStatistics(query.etfs),
    derivative: portfolioStatistics(query.derivative),
    bonds: portfolioStatistics(query.bonds),
    crypto: portfolioStatistics(query.crypto),
    currencies: portfolioStatistics(query.currencies),
    preciousMetals: portfolioStatistics(query.preciousMetals),
  };
};
